import Dashboard from "../../components/dash/global/Dasboard";
import MisTalentosPage from "../../pages/test/MisTalentosPage";
import QuizPage from "../../pages/test/Quiz/QuizPage";
import TestPage from "../../pages/test/TestPage";
import { ROLES } from "../role.constants";

export const studentRoutes = [
  {
    path: "/",
    element: <TestPage />,
    roles: [ROLES.ESTUDIANTE],
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    roles: [ROLES.ESTUDIANTE],
  },
  {
    path: "/test-quiz",
    element: <QuizPage />,
    roles: [ROLES.ESTUDIANTE],
  },
  {
    path: "/mis-talentos",
    element: <MisTalentosPage />,
    roles: [ROLES.ESTUDIANTE],
  },
];
